<template>
  <footer class="footer">
    <div class="social-links">
      <a href="mailto:raulnaharro0@gmail.com" class="contact-link">
        <font-awesome-icon :icon="['fas', 'envelope']" class="contact-icon" />
      </a>
      <a
        href="https://linkedin.com/in/raulnaharro"
        target="_blank"
        class="contact-link"
      >
        <font-awesome-icon :icon="['fab', 'linkedin']" class="contact-icon" />
      </a>
      <a href="https://github.com/Zakees" target="_blank" class="contact-link">
        <font-awesome-icon :icon="['fab', 'github']" class="contact-icon" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
.footer {
  padding: 20px;
  text-align: center;
  background-color: #333;
  color: white;
}

.social-links {
  margin-bottom: 10px;
}

.social-links a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
  font-size: 2rem;
  transition: color 0.3s;
}

.social-links a:hover {
  color: #42b983;
}

p {
  font-size: 0.9rem;
  margin: 0;
}
/* Estilos para el modo oscuro */
.dark-mode .footer {
  background-color: #2a2a40;
  color: #f0f0f0;
}

.dark-mode .social-links a {
  color: #f0f0f0;
}

.dark-mode .social-links a:hover {
  color: #42b983;
}
</style>
